export interface PaymentAccount {
  paymentAccountUUID: string;
  status: string;
  name: string;
  accountNumberLast4: string;
  reason: string;
  accountType: string;
}

export const emptyPaymentAccount: PaymentAccount = {
  paymentAccountUUID: '',
  status: '',
  name: '',
  accountNumberLast4: '',
  reason: '',
  accountType: '',
};
